<template>
  <v-container fluid class="main-container">
    <div class="content-box">
      <swiper class="swiper" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in surveyList" :key="item.id">
          <survey-question-card
            @next="next"
            :question-type="item.type"
            :question-category="item.category"
            :question-number="item.number"
            :question-message="item.message"
            :question-title="item.title"
            :question-id="item.id"
            :question-sub-category="item.subCategory"
            :max-text="item.maxText"
            :question-predicate="item.predicate"
            :answer-list="item.answerList"
            :question-list="item.questionList"
            :email-type="item.isEmail"
            :body="item.body"
            :target="item.target"
          />
        </swiper-slide>
      </swiper>
    </div>
    <div class="d-flex align-center bottom-bar">
      <v-progress-linear :value="progress()" />
      <v-btn icon x-large @click="prev" color="secondary">
        <v-icon large>mdi-arrow-up-drop-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-large @click="next" color="secondary">
        <v-icon large>mdi-arrow-down-drop-circle-outline</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import SurveyQuestionCard from '@/components/SurveyQuestionCard'
// import surveyData from '@/store/surveyFinance.json'
export default {
  name: 'FinanceSurvey',
  components: {
    SurveyQuestionCard,
  },
  async created() {
    this.surveyList = await this.fetchSurvey()
  },
  mounted() {},
  data: () => ({
    swiperOption: {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 30,
      // mousewheel: true,
      speed: 300,
      allowTouchMove: false,
      // allowSlidePrev: false,
      // allowSlideNext: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    },
    currentSlideSeq: 0,
    surveyList: null,
  }),
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  methods: {
    async fetchSurvey() {
      const k = await this.axios.get('/api/survey_finance').then((res) => res.data)
      console.log('==> fetch : survey_finance')
      return k
    },
    next() {
      this.swiper.slideNext()
      this.currentSlideSeq++
    },
    prev() {
      this.swiper.slidePrev()
      this.currentSlideSeq--
      if (this.currentSlideSeq < 0) this.currentSlideSeq = 0
    },
    progress() {
      return (this.currentSlideSeq / (this.surveyList || [1]).length) * 100
    },
  },
}
</script>
<style scoped lang="scss"></style>
